import React from 'react'; 
import { SkinTones, CardBackground, CardBackgroundSelected } from '../constants.mjs';

const SkinSelector = ({setAvatarState, avatarState}) => {

    // Background color property is for skin tones

    return (
        <div className={'grid grid-cols-4 overflow-y-scroll overflow-hidden no-scrollbar w-full flex h-48'}>
            {Object.keys(SkinTones).map((skin) => {
                const isSelected = avatarState.backgroundColor === SkinTones[skin].toString();
                return  <button key={skin.toString()} margin={2} onClick={() => 
                    setAvatarState({
                        ...avatarState,
                        backgroundColor: SkinTones[skin].toString()
                    })}>
                        <div className={isSelected ? CardBackgroundSelected : CardBackground} key={skin.toString()} margin={2}>
                            <svg viewBox="0 0 300 235" xmlns="http://www.w3.org/2000/svg">
                                <ellipse cx="150" cy="120" rx="100" ry="100" fill={SkinTones[skin.toString()]} />
                            </svg>
                        </div>
                    </button>
                })
            }
        </div>
    );
}

export default SkinSelector;